import { useAppStore } from '../store/appStore';
import { parseInternationalPhoneNumber } from './phoneNumber';

/**
 * Defaults that follow the current business (Settings → Business profile), so new
 * records and inputs start where the business works instead of USD / Egypt.
 */

/** The business currency; USD only when the business has none set. */
export function businessCurrency(): string {
  const currency = useAppStore.getState().currentBusiness?.currency;
  return typeof currency === 'string' && /^[A-Z]{3}$/i.test(currency) ? currency.toUpperCase() : 'USD';
}

/**
 * Country (ISO-2, e.g. "SA") for a new, empty phone input: the business country, then the
 * signed-in user's own phone country, then Egypt. Existing numbers keep their own country.
 */
export function defaultPhoneCountry(): string {
  const { currentBusiness, user } = useAppStore.getState() as any;
  const country = currentBusiness?.country;
  if (typeof country === 'string' && /^[A-Z]{2}$/i.test(country)) return country.toUpperCase();
  const mobile = user?.mobile || user?.phone;
  if (mobile) {
    try {
      const parsed = parseInternationalPhoneNumber(String(mobile).startsWith('+') ? String(mobile) : `+${mobile}`);
      if (parsed?.country) return String(parsed.country).toUpperCase();
    } catch { /* fall through */ }
  }
  return 'EG';
}
